import {
  createProduct as apiCreateProduct,
  deleteProduct as apiDeleteProduct,
  getAdminProduct,
  getAllAdminProducts,
  getPublicProduct,
  getPublicProducts,
  updateProduct as apiUpdateProduct,
} from '../lib/api';
import type {
  AdminProductsQuery,
  ProductCard,
  ProductCreateInput,
  ProductDetail,
  ProductUpdateInput,
  PublicProductsQuery,
} from '../types/product';

export async function getProducts(): Promise<ProductCard[]> {
  return getAllAdminProducts();
}

export {
  getAdminProduct,
  getPublicProduct,
  getPublicProducts,
  apiCreateProduct as createProduct,
  apiUpdateProduct as updateProduct,
  apiDeleteProduct as deleteProduct,
};

export type { ProductCard, ProductDetail, ProductCreateInput, ProductUpdateInput, PublicProductsQuery, AdminProductsQuery };
